import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import { FieldArray, reduxForm, SubmissionError } from 'redux-form';

import * as validate from 'utils/validate';

import { sendShareEmail } from 'redux/modules/emails';

import ShareEmailFormFieldArray from './ShareEmailFormFieldArray';

function onSubmit(values, dispatch) {
  return new Promise((resolve, reject) => {
    dispatch(sendShareEmail({
      values: {
        Emails: values.Emails.filter(item => item),
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const ShareEmailForm = ({
  handleSubmit, className,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Grid container justify="center" spacing={24}>
      <Grid item xs={12}>
        <FieldArray
          name="Emails"
          placeholder="Share via Email"
          component={ShareEmailFormFieldArray}
          validate={[
            values => validate.required(values[0]),
            values => values.reduce((accumulator, currentValue) => accumulator
                || validate.email(currentValue), undefined),
          ]}
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

ShareEmailForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

ShareEmailForm.defaultProps = {
  className: '',
};

export default reduxForm({
  onSubmit,
  initialValues: {
    Emails: [''],
  },
})(ShareEmailForm);



// WEBPACK FOOTER //
// ./src/components/common/ShareDialog/ShareEmailForm.js